var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import store from '../../../store';
import DtoConverter from '../../../core/utils/dto-converter';
import FraimsyApi from '../../../core/api/fraimsy-api';
import { Product } from '../../../models/product';
import { FETCH_PRODUCT_ERROR, FETCH_PRODUCT_REQUEST, FETCH_PRODUCT_SUCCESS, FETCH_PRODUCTS_ERROR, FETCH_PRODUCTS_REQUEST, FETCH_PRODUCTS_SUCCESS, } from './actionTypes';
export var fetchProducts = function (force) {
    if (force === void 0) { force = false; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var state, response, items, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = store.getState();
                    if (!force && 'loaded' === state.products.collection.status) {
                        return [2 /*return*/, state.products.collection.items];
                    }
                    dispatch({ type: FETCH_PRODUCTS_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, FraimsyApi.get("products")];
                case 2:
                    response = _a.sent();
                    if (response.status !== 200) {
                        // TODO: error handling
                    }
                    items = DtoConverter.createList(Product, response.data.data);
                    dispatch({ type: FETCH_PRODUCTS_SUCCESS, items: items });
                    return [2 /*return*/, items];
                case 3:
                    err_1 = _a.sent();
                    dispatch({ type: FETCH_PRODUCTS_ERROR });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchProduct = function (slug) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: FETCH_PRODUCT_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.get("products/" + slug)];
            case 2:
                response = _a.sent();
                if (response.status !== 200) {
                    // TODO: error handling
                }
                item = new Product(response.data.data);
                dispatch({ type: FETCH_PRODUCT_SUCCESS, item: item });
                return [2 /*return*/, item];
            case 3:
                err_2 = _a.sent();
                dispatch({ type: FETCH_PRODUCT_ERROR });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
